import { render, staticRenderFns } from "./VisaExpiredVisaTypeWise.vue?vue&type=template&id=8610ca20&"
import script from "./VisaExpiredVisaTypeWise.vue?vue&type=script&lang=js&"
export * from "./VisaExpiredVisaTypeWise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports